export const isPasswordDifferent = (
  password: string,
  passwordCheck: string
): boolean => password !== passwordCheck;
